import DOMPurify from 'dompurify';
import { ExternalLink } from 'lucide-react';
import type { DetailRow } from '../../shared/contracts';
import { Modal } from './Modal';

// Harden links inside sanitized appointment bodies: open in a new tab and never leak the
// opener (DOMPurify already strips scripts/iframes/event-handlers/javascript: URLs). Guarded
// to a DOM context — DOMPurify is window-less (and addHook absent) when imported under node.
if (typeof window !== 'undefined' && typeof DOMPurify.addHook === 'function') {
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.nodeName === 'A') {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });
}

/** Opens an opslag (appointment) and renders its HTML body, sanitized. */
export function OpslagModal({ row, onClose }: { row: DetailRow; onClose: () => void }) {
  const safeHtml = DOMPurify.sanitize(row.html ?? '<p>Intet indhold.</p>');
  return (
    <Modal title={row.title} subtitle={row.meta} onClose={onClose}>
      {row.subtitle && <p className="mb-3 text-sm font-medium text-brand-dark/70">{row.subtitle}</p>}
      <div
        className="text-sm leading-relaxed text-brand-dark/80 [&_li]:ml-5 [&_li]:list-disc [&_p]:my-2 [&_strong]:text-brand-dark [&_ul]:my-2"
        dangerouslySetInnerHTML={{ __html: safeHtml }}
      />
      {row.href && (
        <a href={row.href} target="_blank" rel="noreferrer" className="mt-4 inline-flex items-center gap-1 text-sm text-brand-accent hover:text-brand-accent-hover">
          Åbn i SuperOffice <ExternalLink size={14} />
        </a>
      )}
    </Modal>
  );
}
